module.exports = __webpack_public_path__ + "img/81600.6cef351d.jpg";